import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useQuote } from '@/context/QuoteContext';
import { CATEGORIES } from '@/lib/api';

export default function ProductCard({ product }) {
  const { openQuote } = useQuote();
  const cat = CATEGORIES.find((c) => c.slug === product.category);
  return (
    <Card
      className="group rounded-2xl border-border bg-card shadow-[var(--shadow-soft)] hover:shadow-[var(--shadow-lift)] overflow-hidden transition-shadow flex flex-col"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/produit/${product.slug}`} className="block aspect-[4/3] bg-white overflow-hidden relative p-4">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-contain product-image-zoom"
        />
        {cat && (
          <Badge variant="secondary" className="absolute top-3 left-3 bg-white/95 text-foreground border border-border tracking-[0.06em] text-[10px] uppercase">
            {cat.name}
          </Badge>
        )}
      </Link>
      <div className="p-4 flex-1 flex flex-col">
        {product.brand && (
          <div className="text-[11px] uppercase tracking-[0.08em] text-muted-foreground">{product.brand}</div>
        )}
        <Link to={`/produit/${product.slug}`}>
          <h3 className="mt-1 font-heading font-semibold text-base leading-snug line-clamp-2 group-hover:text-[hsl(186_55%_38%)] transition-colors" title={product.name}>
            {product.name}
          </h3>
        </Link>
        {product.short_description && (
          <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{product.short_description}</p>
        )}
        <div className="mt-4 flex items-center justify-between gap-2">
          <Button
            variant="ghost"
            asChild
            className="px-0 text-foreground hover:text-[hsl(186_55%_38%)]"
          >
            <Link to={`/produit/${product.slug}`} data-testid={`product-card-detail-${product.slug}`} className="text-sm font-medium">
              Détails <ArrowRight className="w-4 h-4 ml-1 inline" />
            </Link>
          </Button>
          <Button
            size="sm"
            onClick={() => openQuote(product)}
            className="rounded-lg bg-[hsl(186_55%_38%)] hover:bg-[hsl(186_55%_32%)] text-white"
            data-testid={`product-card-quote-${product.slug}`}
          >
            Demander un devis
          </Button>
        </div>
      </div>
    </Card>
  );
}
